module.exports = __webpack_public_path__ + "img/plane-engine.e3593b66.png";